export default "__VITE_ASSET__B8lH86t1__"